import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "fileName", "preview", "textarea", "button", "bodyMaxLength"];

  connect() {
    this.element.addEventListener('tinymce:change', () => this.updatePreview());
    this.updatePreview();
  }

  triggerUpload() {
    this.inputTarget.click();
  }

  displayFile() {
    const file = this.inputTarget.files[0];
    this.fileNameTarget.textContent = file ? file.name : "";
    this.previewTarget.parentElement.classList.remove("d-none");

    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewTarget.src = e.target.result;
        this.previewTarget.classList.remove("d-none");
      };
      reader.readAsDataURL(file);
    }

    this.updatePreview();
  }

  removeFile() {
    this.fileNameTarget.textContent = "";
    this.previewTarget.parentElement.classList.add("d-none");
    this.previewTarget.classList.add("d-none");
    this.previewTarget.src = "";
    this.inputTarget.value = null;

    this.updatePreview();
  }

  updatePreview() {
    const hasFile = this.inputTarget.files.length > 0;

    const editor = tinymce.get(this.textareaTarget.id);
    const content = editor?.getContent({ format: "text" }) || "";
    const hasText = content.trim().length > 0;
    const charsLimit = hasFile ? 1024 : 4096;

    this.bodyMaxLengthTarget.textContent = charsLimit;
    this.element.querySelector("form").dataset.messageLimitMaxLengthValue = charsLimit;
    this.buttonTarget.disabled = !(hasFile || hasText);
  }
}
